export const API = process.env.VUE_APP_ROOT_API;
export const VERSION = process.env.VUE_APP_ROOT_API_VERSION;
export const RECAPTCHASITEKEY = process.env.VUE_APP_RECAPTCHASITEKEY;
export const OTPDIGITS = process.env.VUE_APP_OTPDIGITS;
export const OFFLINEREDIRECT = process.env.VUE_APP_OFFLINE_REDIRECT;